import { Box, Skeleton } from "@mui/material";

export const LoadingContentEmpresa = () => {

    return (

        <Box
            sx={{
                maxWidth: 1200,
                mx: 'auto',
                p: { xs: 2, sm: 4 },
                position: 'relative',
            }}
        >
            {/* Skeleton para el header */}
            <Box
                sx={{
                    p: { xs: 2, sm: 3 },
                    borderRadius: 3,
                    bgcolor: (theme) =>
                        theme.palette.mode === 'light'
                            ? 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)'
                            : 'linear-gradient(135deg, #1c2526 0%, #2a3b3c 100%)',
                    boxShadow: (theme) =>
                        theme.palette.mode === 'light'
                            ? '0 6px 16px rgba(0,0,0,0.12)'
                            : '0 6px 16px rgba(255,255,255,0.08)',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: { xs: 2, sm: 3 },
                }}
            >
                <Skeleton
                    variant="rectangular"
                    width={80}
                    height={80}
                    sx={{
                        borderRadius: 2,
                        flexShrink: 0,
                        bgcolor: (theme) => (theme.palette.mode === 'light' ? 'grey.200' : 'grey.700'),
                    }}
                />
                <Box sx={{ flexGrow: 1, minWidth: { xs: '100%', sm: '300px' } }}>
                    <Skeleton
                        variant="text"
                        width="50%"
                        height={40}
                        sx={{
                            fontSize: '1.6rem',
                            mb: 1,
                            bgcolor: (theme) => (theme.palette.mode === 'light' ? 'grey.200' : 'grey.700'),
                        }}
                    />
                    <Skeleton
                        variant="text"
                        width="70%"
                        height={20}
                        sx={{
                            fontSize: '0.95rem',
                            mb: 2,
                            bgcolor: (theme) => (theme.palette.mode === 'light' ? 'grey.200' : 'grey.700'),
                        }}
                    />
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        <Skeleton
                            variant="rounded"
                            width={120}
                            height={30}
                            sx={{
                                borderRadius: '16px',
                                bgcolor: (theme) => (theme.palette.mode === 'light' ? 'grey.200' : 'grey.700'),
                            }}
                        />
                        <Skeleton
                            variant="rounded"
                            width={120}
                            height={30}
                            sx={{
                                borderRadius: '16px',
                                bgcolor: (theme) => (theme.palette.mode === 'light' ? 'grey.200' : 'grey.700'),
                            }}
                        />
                    </Box>
                </Box>
            </Box>
            {/* Skeleton para las pestañas y contenido */}
            <Box sx={{ mt: 3, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
                <Box sx={{ display: 'flex', gap: 2, pt: 1, px: 3 }}>
                    <Skeleton variant="rounded" width={100} height={25} sx={{ borderRadius: 1 }} />
                    <Skeleton variant="rounded" width={100} height={25} sx={{ borderRadius: 1 }} />
                    <Skeleton variant="rounded" width={100} height={25} sx={{ borderRadius: 1 }} />
                </Box>
                <Box sx={{ p: 3 }}>
                    <Skeleton variant="rectangular" height={400} sx={{ borderRadius: 2 }} />
                </Box>
            </Box>
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    bgcolor: (theme) => (theme.palette.mode === 'light' ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)'),
                    zIndex: 1,
                }}
            />
        </Box>
    )


}